module.exports = __webpack_public_path__ + "static/media/twitter.5d804aff.svg";